module.exports = __webpack_public_path__ + "static/media/Globe.9cdd6267.svg";